import { Box, Typography } from "@mui/material";
import {
  FormattedManagementsList,
  ManagementsDetailHeader,
} from "../../../core/models/managements/managements.model";
import "./ManagementsLast.scss";
import { useTranslation } from "react-i18next";
import {
  getManagementStateData,
  getIncidenceIconTitle,
  incedenceTexts,
} from "../../../utils/components/managements/managements.util";
import LoadingComponentComponent from "../../UI/LoadingComponentComponent/LoadingComponentComponent";
import { ManagementsListCard } from "../ManagementsListCard/ManagementsListCard";

interface ManagementsLastProps {
  managementsLastList: FormattedManagementsList[];
  isTableLoading: boolean;
  setManagementsDetailHeader: React.Dispatch<
    React.SetStateAction<ManagementsDetailHeader>
  >;
}
const ManagementsLast = ({
  managementsLastList,
  isTableLoading,
  setManagementsDetailHeader,
}: ManagementsLastProps) => {
  const { t } = useTranslation();

  return (
    <Box component="section" sx={{ paddingTop: { xs: "2.5rem", md: "5rem" } }}>
      <Typography component="h3" variant="h3" paddingBottom="1rem">
        {t("Gestiones.Recientes")}
      </Typography>
      <Typography
        component="p"
        variant="body2"
        sx={{ color: "grey.700" }}
        paddingBottom={{ xs: "1.5rem", md: "2rem" }}
      >
        {!managementsLastList.length && !isTableLoading
          ? t("Gestiones.No hay gestiones recientes")
          : t("Gestiones.Descripción Recientes")}
      </Typography>
      {isTableLoading && (
        <Box padding={"2rem 0"}>
          <LoadingComponentComponent
            isLoading={isTableLoading}
            backgroundColor={"transparent"}
            position={"relative"}
            height={"4rem"}
          />
        </Box>
      )}
      {managementsLastList.length > 0 &&
        managementsLastList.map(
          ({
            issueNumber,
            date,
            state,
            recordTextType,
            claimTextSubType,
            incidenceText,
            socialReason,
            cups,
            idSubType,
            cif,
          }) => {
            const { color, backgroundColor, icon, label } =
              getManagementStateData(state);
            const isIncidenceText = incedenceTexts.some(
              (incidenceMatchingText) =>
                incidenceText.includes(incidenceMatchingText),
            );
            const incidenceIconTitle = getIncidenceIconTitle(
              incedenceTexts,
              incidenceText,
            );

            return (
              <>
                <ManagementsListCard
                  backgroundColor={backgroundColor}
                  color={color}
                  icon={icon}
                  label={label}
                  socialReason={socialReason}
                  cups={cups}
                  cif={cif}
                  incidenceIconTitle={incidenceIconTitle}
                  date={date}
                  idSubType={idSubType}
                  issueNumber={issueNumber}
                  setManagementsDetailHeader={setManagementsDetailHeader}
                  recordTextType={recordTextType}
                  claimTextSubType={claimTextSubType}
                  incidenceText={incidenceText}
                  isIncidenceText={isIncidenceText}
                />
              </>
            );
          },
        )}
    </Box>
  );
};

export default ManagementsLast;
